import { css } from 'lit';

export const styles = css `
  :host {
    display: block;
    --u-menu-item-label-font-weight: var(--u-typeahead-item-font-weight, var(--u-font-weight-regular, 400));
  }

  :host([fit-target]) u-menu::part(menu) {
    width: var(--_menu-width);
    max-width: none;
  }
`;
